import React, { Component } from "react";
import TopNav from "../containers/TopNav/TopNav";
import LandingWhiteMonday from '../containers/HomeBanners/LandingWhiteMonday';
import WhiteMondayHowItWorksSection from "../components/WhiteMondayHowItWorksSection";
import WhiteMondayGiftCards from "../components/WhiteMondayGiftCards";
import WhiteMondayGifts from "../components/WhiteMondayGifts";
import WhiteMondayAboutIhopa from "../components/WhiteMondayAboutIhopa";
import WhiteMondayReadyToGift from "../components/WhiteMondayReadyToGift";
import Footer from "../containers/Footer";
import AppWrapper from "../containers/AppWrapper";

class WhiteMonday extends Component {
  render() {
    return (
      <AppWrapper>
        <TopNav />
        <LandingWhiteMonday />
        <WhiteMondayHowItWorksSection />
        <WhiteMondayGiftCards />
        <WhiteMondayGifts />
        <WhiteMondayAboutIhopa />
        <WhiteMondayReadyToGift />
        <Footer />
      </AppWrapper>
    );
  }
}

export default WhiteMonday;
